export const foodTags = [
  "sweet",
  "salty",
  "sour",
  "bitter",
  "umami",
  "fatty",
  "spicy",
  "tangy",
  "savory",
  "smoky",
  "herbal",
  "earthy",
  "fruity",
  "nutty",
  "creamy",
  "fresh",
  "crisp",
  "fermented",
  "vegan",
  "vegetarian",
  "gluten-free",
  "dairy-free",
  "lactose-free",
  "nut-free",
  "keto",
  "low-carb",
  "halal",
  "kosher",
  "BBQ",
  "pescatarian",
  "low-sodium",
  "organic",
  "low-FODMAP",
  "comforting",
  "light",
  "refreshing",
  "indulgent",
  "decadent",
  "energizing",
  "hydrating",
  "slow-cooked",
  "sous-vide",
  "grilled",
  "smoked",
  "seared",
  "braised",
  "roasted",
  "steamed",
  "fried",
  "pickled",
  "cured",
  "raw",
  "caramelized",
  "glazed",
  "marinated",
  "blanched",
  "baked",
  "pan-fried",
  "crunchy",
  "chewy",
  "tender",
  "juicy",
  "flaky",
  "dense",
  "airy",
  "silky",
  "velvety",
  "gelatinous",
  "buttery",
  "oily",
  "zesty",
  "sharp",
  "mellow",
  "pungent",
  "acidic",
  "floral",
  "peppery",
  "toasted",
  "syrupy",
  "crumbly",
  "Asian",
  "European",
  "Mediterranean",
  "Mexican",
  "Middle Eastern",
  "Indian",
  "Chinese",
  "Japanese",
  "Thai",
  "Korean",
  "Vietnamese",
  "Filipino",
  "Malaysian",
  "Indonesian",
  "Turkish",
  "Lebanese",
  "Moroccan",
  "Spanish",
  "French",
  "Italian",
  "Syrian",
  "Iraqi",
  "Egyptian",
  "American",
];

// src/constants/foodTags.tsx


import { FaFire, FaLeaf, FaSnowflake } from 'react-icons/fa';
import {
  FiAnchor,
  FiCheck,
  FiCircle,
  FiCloud,
  FiCoffee,
  FiDroplet,
  FiFeather,
  FiFlag,
  FiGift,
  FiGlobe,
  FiHeart,
  FiMapPin,
  FiMoon,
  FiShield,
  FiSquare,
  FiStar,
  FiSun,
  FiThermometer,
  FiTrendingDown,
  FiTriangle,
  FiWind,
  FiX,
  FiZap
} from 'react-icons/fi';
import {
  GiButter,
  GiChiliPepper,
  GiGarlic,
  GiHoneyJar,
  GiHotSpices,
  GiMushroomGills,
  GiOlive
} from 'react-icons/gi';
import { LuNut } from "react-icons/lu";
import {
  TbApple,
  TbBread,
  TbCandy,
  TbCarrot,
  TbCookie,
  TbFish,
  TbIceCream,
  TbLemon,
  TbSalt,
  TbSoup
} from 'react-icons/tb';


export const FOOD_TAGS = [
  { id: 0, labelEn: "Sweet", labelAr: "حلو", color: "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400", icon: <TbCandy className="w-4 h-4" /> },
  { id: 1, labelEn: "Salty", labelAr: "مالح", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <TbSalt className="w-4 h-4" /> },
  { id: 2, labelEn: "Sour", labelAr: "حامض", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <TbLemon className="w-4 h-4" /> },
  { id: 3, labelEn: "Bitter", labelAr: "مر", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <FiCoffee className="w-4 h-4" /> },
  { id: 4, labelEn: "Umami", labelAr: "أومامي", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400", icon: <GiMushroomGills className="w-4 h-4" /> },
  { id: 5, labelEn: "Fatty", labelAr: "دهني", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <GiButter className="w-4 h-4" /> },
  { id: 6, labelEn: "Spicy", labelAr: "حار", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <GiChiliPepper className="w-4 h-4" /> },
  { id: 7, labelEn: "Tangy", labelAr: "لاذع", color: "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400", icon: <FiZap className="w-4 h-4" /> },
  { id: 8, labelEn: "Savory", labelAr: "لذيذ", color: "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400", icon: <FiStar className="w-4 h-4" /> },
  { id: 9, labelEn: "Smoky", labelAr: "مدخن", color: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400", icon: <FiCloud className="w-4 h-4" /> },
  { id: 10, labelEn: "Herbal", labelAr: "عشبي", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FaLeaf className="w-4 h-4" /> },
  { id: 11, labelEn: "Earthy", labelAr: "ترابي", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <FiAnchor className="w-4 h-4" /> },
  { id: 12, labelEn: "Fruity", labelAr: "فاكهي", color: "bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-400", icon: <TbApple className="w-4 h-4" /> },
  { id: 13, labelEn: "Nutty", labelAr: "جوزي", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <LuNut className="w-4 h-4" /> },
  { id: 14, labelEn: "Creamy", labelAr: "كريمي", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <TbIceCream className="w-4 h-4" /> },
  { id: 15, labelEn: "Fresh", labelAr: "طازج", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400", icon: <FiWind className="w-4 h-4" /> },
  { id: 16, labelEn: "Crisp", labelAr: "مقرمش", color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400", icon: <FaSnowflake className="w-4 h-4" /> },
  { id: 17, labelEn: "Fermented", labelAr: "مخمر", color: "bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400", icon: <FiCircle className="w-4 h-4" /> },
  { id: 18, labelEn: "Vegan", labelAr: "نباتي صرف", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400", icon: <FaLeaf className="w-4 h-4" /> },
  { id: 19, labelEn: "Vegetarian", labelAr: "نباتي", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <TbCarrot className="w-4 h-4" /> },
  { id: 20, labelEn: "Gluten-Free", labelAr: "خالي من الغلوتين", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <FiX className="w-4 h-4" /> },
  { id: 21, labelEn: "Dairy-Free", labelAr: "خالي من الألبان", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiX className="w-4 h-4" /> },
  { id: 22, labelEn: "Lactose-Free", labelAr: "خالي من اللاكتوز", color: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-400", icon: <FiX className="w-4 h-4" /> },
  { id: 23, labelEn: "Nut-Free", labelAr: "خالي من المكسرات", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400", icon: <FiX className="w-4 h-4" /> },
  { id: 24, labelEn: "Keto", labelAr: "كيتو", color: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400", icon: <FiTrendingDown className="w-4 h-4" /> },
  { id: 25, labelEn: "Low-Carb", labelAr: "قليل الكربوهيدرات", color: "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400", icon: <FiTrendingDown className="w-4 h-4" /> },
  { id: 26, labelEn: "Halal", labelAr: "حلال", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FiCheck className="w-4 h-4" /> },
  { id: 27, labelEn: "Kosher", labelAr: "كوشر", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiCheck className="w-4 h-4" /> },
  { id: 28, labelEn: "BBQ", labelAr: "باربكيو", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FaFire className="w-4 h-4" /> },
  { id: 29, labelEn: "Pescatarian", labelAr: "نباتي يتناول السمك", color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400", icon: <TbFish className="w-4 h-4" /> },
  { id: 30, labelEn: "Low-Sodium", labelAr: "قليل الصوديوم", color: "bg-slate-100 text-slate-800 dark:bg-slate-900/30 dark:text-slate-400", icon: <FiTrendingDown className="w-4 h-4" /> },
  { id: 31, labelEn: "Organic", labelAr: "عضوي", color: "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400", icon: <FiShield className="w-4 h-4" /> },
  { id: 32, labelEn: "Low-FODMAP", labelAr: "قليل الفودماب", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400", icon: <FiTrendingDown className="w-4 h-4" /> },
  { id: 33, labelEn: "Comforting", labelAr: "مريح", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FiHeart className="w-4 h-4" /> },
  { id: 34, labelEn: "Light", labelAr: "خفيف", color: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-400", icon: <FiFeather className="w-4 h-4" /> },
  { id: 35, labelEn: "Refreshing", labelAr: "منعش", color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/30 dark:text-cyan-400", icon: <FiDroplet className="w-4 h-4" /> },
  { id: 36, labelEn: "Indulgent", labelAr: "فاخر", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400", icon: <FiGift className="w-4 h-4" /> },
  { id: 37, labelEn: "Decadent", labelAr: "غني", color: "bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400", icon: <FiGift className="w-4 h-4" /> },
  { id: 38, labelEn: "Energizing", labelAr: "منشط", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <FiZap className="w-4 h-4" /> },
  { id: 39, labelEn: "Hydrating", labelAr: "مرطب", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiDroplet className="w-4 h-4" /> },
  { id: 40, labelEn: "Slow-Cooked", labelAr: "مطبوخ ببطء", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <FiMoon className="w-4 h-4" /> },
  { id: 41, labelEn: "Sous-Vide", labelAr: "سو فيد", color: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400", icon: <FiThermometer className="w-4 h-4" /> },
  { id: 42, labelEn: "Grilled", labelAr: "مشوي", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FaFire className="w-4 h-4" /> },
  { id: 43, labelEn: "Smoked", labelAr: "مدخن", color: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400", icon: <FiCloud className="w-4 h-4" /> },
  { id: 44, labelEn: "Seared", labelAr: "محمر", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FaFire className="w-4 h-4" /> },
  { id: 45, labelEn: "Braised", labelAr: "مطبوخ في المرق", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <TbSoup className="w-4 h-4" /> },
  { id: 46, labelEn: "Roasted", labelAr: "محمص", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FiSun className="w-4 h-4" /> },
  { id: 47, labelEn: "Steamed", labelAr: "مطبوخ بالبخار", color: "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400", icon: <FiCloud className="w-4 h-4" /> },
  { id: 48, labelEn: "Fried", labelAr: "مقلي", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <FaFire className="w-4 h-4" /> },
  { id: 49, labelEn: "Pickled", labelAr: "مخلل", color: "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400", icon: <FiDroplet className="w-4 h-4" /> },
  { id: 50, labelEn: "Cured", labelAr: "معالج", color: "bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-400", icon: <FiShield className="w-4 h-4" /> },
  { id: 51, labelEn: "Raw", labelAr: "نيء", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400", icon: <FiCircle className="w-4 h-4" /> },
  { id: 52, labelEn: "Caramelized", labelAr: "مكرمل", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <GiHoneyJar className="w-4 h-4" /> },
  { id: 53, labelEn: "Glazed", labelAr: "مطلي", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FiSun className="w-4 h-4" /> },
  { id: 54, labelEn: "Marinated", labelAr: "متبل", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <GiHotSpices className="w-4 h-4" /> },
  { id: 55, labelEn: "Blanched", labelAr: "مسلوق سريعاً", color: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-400", icon: <FiDroplet className="w-4 h-4" /> },
  { id: 56, labelEn: "Baked", labelAr: "مخبوز", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <TbBread className="w-4 h-4" /> },
  { id: 57, labelEn: "Pan-Fried", labelAr: "مقلي في المقلاة", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FaFire className="w-4 h-4" /> },
  { id: 58, labelEn: "Crunchy", labelAr: "مقرمش", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <FaSnowflake className="w-4 h-4" /> },
  { id: 59, labelEn: "Chewy", labelAr: "مطاطي", color: "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400", icon: <FiCircle className="w-4 h-4" /> },
  { id: 60, labelEn: "Tender", labelAr: "طري", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FiFeather className="w-4 h-4" /> },
  { id: 61, labelEn: "Juicy", labelAr: "عصاري", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FiDroplet className="w-4 h-4" /> },
  { id: 62, labelEn: "Flaky", labelAr: "متقشر", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiFeather className="w-4 h-4" /> },
  { id: 63, labelEn: "Dense", labelAr: "كثيف", color: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400", icon: <FiSquare className="w-4 h-4" /> },
  { id: 64, labelEn: "Airy", labelAr: "هوائي", color: "bg-sky-100 text-sky-800 dark:bg-sky-900/30 dark:text-sky-400", icon: <FiWind className="w-4 h-4" /> },
  { id: 65, labelEn: "Silky", labelAr: "حريري", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400", icon: <FiFeather className="w-4 h-4" /> },
  { id: 66, labelEn: "Velvety", labelAr: "مخملي", color: "bg-violet-100 text-violet-800 dark:bg-violet-900/30 dark:text-violet-400", icon: <FiFeather className="w-4 h-4" /> },
  { id: 67, labelEn: "Gelatinous", labelAr: "جيلاتيني", color: "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400", icon: <FiDroplet className="w-4 h-4" /> },
  { id: 68, labelEn: "Buttery", labelAr: "زبدي", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <GiButter className="w-4 h-4" /> },
  { id: 69, labelEn: "Oily", labelAr: "زيتي", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <GiOlive className="w-4 h-4" /> },
  { id: 70, labelEn: "Zesty", labelAr: "حيوي", color: "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400", icon: <FiZap className="w-4 h-4" /> },
  { id: 71, labelEn: "Sharp", labelAr: "حاد", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FiTriangle className="w-4 h-4" /> },
  { id: 72, labelEn: "Mellow", labelAr: "ناعم", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FiCircle className="w-4 h-4" /> },
  { id: 73, labelEn: "Pungent", labelAr: "نفاذ", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <GiGarlic className="w-4 h-4" /> },
  { id: 74, labelEn: "Acidic", labelAr: "حمضي", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <TbLemon className="w-4 h-4" /> },
  { id: 75, labelEn: "Floral", labelAr: "زهري", color: "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400", icon: <FiSun className="w-4 h-4" /> },
  { id: 76, labelEn: "Peppery", labelAr: "فلفلي", color: "bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400", icon: <GiChiliPepper className="w-4 h-4" /> },
  { id: 77, labelEn: "Toasted", labelAr: "محمص", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <TbBread className="w-4 h-4" /> },
  { id: 78, labelEn: "Syrupy", labelAr: "شرابي", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <GiHoneyJar className="w-4 h-4" /> },
  { id: 79, labelEn: "Crumbly", labelAr: "متفتت", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <TbCookie className="w-4 h-4" /> },
  { id: 80, labelEn: "Asian", labelAr: "آسيوي", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FiGlobe className="w-4 h-4" /> },
  { id: 81, labelEn: "European", labelAr: "أوروبي", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiGlobe className="w-4 h-4" /> },
  { id: 82, labelEn: "Mediterranean", labelAr: "متوسطي", color: "bg-teal-100 text-teal-800 dark:bg-teal-900/30 dark:text-teal-400", icon: <FiMapPin className="w-4 h-4" /> },
  { id: 83, labelEn: "Mexican", labelAr: "مكسيكي", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 84, labelEn: "Middle Eastern", labelAr: "شرق أوسطي", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FiMapPin className="w-4 h-4" /> },
  { id: 85, labelEn: "Indian", labelAr: "هندي", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 86, labelEn: "Chinese", labelAr: "صيني", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 87, labelEn: "Japanese", labelAr: "ياباني", color: "bg-pink-100 text-pink-800 dark:bg-pink-900/30 dark:text-pink-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 88, labelEn: "Thai", labelAr: "تايلندي", color: "bg-lime-100 text-lime-800 dark:bg-lime-900/30 dark:text-lime-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 89, labelEn: "Korean", labelAr: "كوري", color: "bg-rose-100 text-rose-800 dark:bg-rose-900/30 dark:text-rose-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 90, labelEn: "Vietnamese", labelAr: "فيتنامي", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 91, labelEn: "Filipino", labelAr: "فلبيني", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 92, labelEn: "Malaysian", labelAr: "ماليزي", color: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900/30 dark:text-indigo-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 93, labelEn: "Indonesian", labelAr: "إندونيسي", color: "bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 94, labelEn: "Turkish", labelAr: "تركي", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 95, labelEn: "Lebanese", labelAr: "لبناني", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 96, labelEn: "Moroccan", labelAr: "مغربي", color: "bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 97, labelEn: "Spanish", labelAr: "إسباني", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 98, labelEn: "French", labelAr: "فرنسي", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 99, labelEn: "Italian", labelAr: "إيطالي", color: "bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 100, labelEn: "Syrian", labelAr: "سوري", color: "bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 101, labelEn: "Iraqi", labelAr: "عراقي", color: "bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 102, labelEn: "Egyptian", labelAr: "مصري", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400", icon: <FiFlag className="w-4 h-4" /> },
  { id: 103, labelEn: "American", labelAr: "أمريكي", color: "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400", icon: <FiGlobe className="w-4 h-4" /> }
];